import React, { useState } from "react";
import useUpdate from "../../../../../api/useUpdate";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const EditMedicine = ({ open, onClose, medicine, categoryData, token }) => {
  const { t } = useTranslation();
  const [name, setName] = useState(medicine?.name || "");
  const [nameError, setNameError] = useState("");
  const [category, setCategory] = useState(
    (categoryData || []).find((cat) => cat.id === medicine.category) || null,
  );
  const [description, setDescription] = useState(medicine?.description || "");
  const [barcode, setBarcode] = useState(medicine?.barcode || "");

  const { handleUpdate } = useUpdate("medicines", token, null);

  const handleSubmit = (e) => {
    e.preventDefault();
    let isValid = true;

    if (!name) {
      setNameError(t("pharmacy.nameRequired"));
      isValid = false;
    } else {
      setNameError("");
    }

    if (isValid) {
      handleUpdate(medicine.id, {
        name,
        category: category?.id || null,
        description,
        barcode: barcode || "",
      });
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      component="form"
      onSubmit={handleSubmit}
    >
      <DialogTitle>{t("pharmacy.updateMedicine")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={t("pharmacy.medicineName")}
          fullWidth
          variant="outlined"
          value={name}
          error={!!nameError}
          helperText={nameError}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          margin="dense"
          label={t("pharmacy.barcode")}
          fullWidth
          variant="outlined"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          helperText={t("pharmacy.barcodeOptionalHelp")}
        />
        <Autocomplete
          options={categoryData || []}
          getOptionLabel={(option) => option.name}
          value={category || null}
          onChange={(event, newValue) => {
            if (newValue) {
              setCategory(newValue);
            } else {
              setCategory(null);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              label={t("pharmacy.category")}
              variant="outlined"
              helperText={t("pharmacy.categoryOptionalHelp")}
            />
          )}
          fullWidth
        />

        <TextField
          margin="dense"
          label={t("pharmacy.description")}
          fullWidth
          multiline
          rows={4}
          value={description}
          helperText={t("pharmacy.descriptionOptionalHelp")}
          onChange={(e) => setDescription(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="warning">
          {t("pharmacy.cancel")}
        </Button>
        <Button
          variant="contained"
          color="success"
          type="submit"
          sx={{ margin: "0px 10px" }}
        >
          {t("pharmacy.update")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMedicine;
